// extracted by mini-css-extract-plugin
export default {"calculatorLoaderWrapper":"CalculatorLoader_calculatorLoaderWrapper__7q9-y","loadingMessage":"CalculatorLoader_loadingMessage__JDVv1"};